import { createBrowserHistory as createHistory } from 'history';

const history = createHistory();

if (window.Cypress) {
  window.tgHistory = history;
}

export default history;
